export default function toSecondsAndMinutes(seconds: number): string {
    const secondsOnly = Math.floor(seconds % 60);
    const minutesOnly = Math.floor(seconds / 60);

    return `${minutesOnly}:${
        secondsOnly < 10 ? `0${secondsOnly}` : secondsOnly
    }`;
}
